export default __webpack_public_path__ + "static/media/YAS0840.34I-37994_-25391_0.99ab24b6.jpg";